import { useMediaQuery } from '@patrianna/shared-hooks'

const HEADER_HEIGHT = 56

export const useVerticalPageIndex = () => {
  const isMobile = useMediaQuery('xs')

  const getVerticalPageIndex = (yPositionOfClickedTile: number) => {
    const headerHeightDiff = isMobile ? 2 * HEADER_HEIGHT : HEADER_HEIGHT
    const absoluteYPosition = yPositionOfClickedTile + window.scrollY - headerHeightDiff
    const viewportHeight = window.innerHeight - headerHeightDiff

    return Math.ceil(absoluteYPosition / viewportHeight)
  }

  return getVerticalPageIndex
}
